module.exports = __webpack_public_path__ + "static/media/ma_pani_pachi_kalakar.9ac2211e.ogg";